// extracted by mini-css-extract-plugin
module.exports = {"list":"list--P8Nxd","selectedItem":"selectedItem--DStS0"};